'use client';
import React from 'react';
import MyOrders from './MyOrders';
import MyWishList from './MyWishList';
import MyRewards from './MyRewards';
import AccountDetails from './AccountDetails';

export type DashboardCardName =
  | 'My Orders'
  | 'Account Details'
  | 'My WishList'
  | 'My Rewards';

interface DashboardContentRendererProps {
  activeCard: DashboardCardName | null;
}

const DashboardContentRenderer: React.FC<DashboardContentRendererProps> = ({
  activeCard,
}) => {
  switch (activeCard) {
    case 'My Orders':
      return <MyOrders />;
    case 'Account Details':
      return <AccountDetails />;
    case 'My WishList':
      return <MyWishList />;
    case 'My Rewards':
      return <MyRewards />;
    default:
      return null;
  }
};

export default DashboardContentRenderer;
